<template>
  <div id="login_body">
    <div id="full_login_form">
      <div id="login_header">
        <HeaderLogin />
      </div>
      <div id="login_content">
        <div id="login_form">
          <div id="login_title">
            {{ messages.loginH[store.langSelect.value] }}
          </div>
          <div
            :class="[
              !loginClass
                ? 'login_form_input el-input'
                : 'login_form_input_error el-input',
            ]"
          >
            <div class="el-input__wrapper">
              <input
                :placeholder="messages.userName[store.langSelect.value]"
                v-model="login"
                class="el-input__inner"
              />
            </div>
          </div>
          <div style="margin-top: -20px; margin-bottom: 5px; height: 15px">
              <span
                v-if="errLogin != ''"
                id="errLogin"
                v-text="messages.loginErr[store.langSelect.value]"
              >
              </span>
            </div>
          <div>
            <!--    <input :placeholder="messages.password[store.langSelect.value]" type="password"  autocomplete="off" v-model="password" :class="[
                  !passwordClass ? 'login_form_input' : 'login_form_input_error',
                ]"/> -->
            <el-input
              :placeholder="messages.password[store.langSelect.value]"
              v-model="password"
              :show-password="true"
              :class="[
                !passwordClass
                  ? 'login_form_input_pass'
                  : 'login_form_input_pass_error',
              ]"
            ></el-input>
            <div style="margin-top: -20px; margin-bottom: 5px; height: 15px">
              <!-- <span v-if="errPass != ''" id="errPass" v-text="messages.loginErr[store.langSelect.value]"> </span> -->
            </div>
          </div>
          <div id="login_link_group">
            <Button
              style="width: 180px"
              @click="SubmitCode"
              :text="messages.login[store.langSelect.value]"
            />
            <div style="margin-top: 12px; margin-left: 30px">
              <router-link to="forgot">{{
                messages.forgotPassword[store.langSelect.value]
              }}</router-link>
            </div>
          </div>
          <div id="login_register">
            <router-link to="register">{{
              messages.registerNew[store.langSelect.value]
            }}</router-link>
          </div>
        </div>
        <div
          id="login_img"
          :style="{
            background:
              'url(' +
              store.serverConf[store.currentServer].path +
              '/images/Rectangle24.png)',
          }"
        >
          <svg
            style="position: absolute; top: 30px; right: 30px"
            width="107"
            height="107"
            viewBox="0 0 107 107"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g style="mix-blend-mode: hard-light">
              <circle cx="1.5" cy="1.5" r="1.5" fill="#E9E9E9" />
              <circle cx="1.5" cy="27.5" r="1.5" fill="#E9E9E9" />
              <circle cx="1.5" cy="53.5" r="1.5" fill="#E9E9E9" />
              <circle cx="1.5" cy="79.5" r="1.5" fill="#E9E9E9" />
              <circle cx="1.5" cy="105.5" r="1.5" fill="#E9E9E9" />
              <circle cx="27.5" cy="1.5" r="1.5" fill="#E9E9E9" />
              <circle cx="27.5" cy="27.5" r="1.5" fill="#E9E9E9" />
              <circle cx="27.5" cy="53.5" r="1.5" fill="#E82862" />
              <circle cx="27.5" cy="79.5" r="1.5" fill="#E9E9E9" />
              <circle cx="27.5" cy="105.5" r="1.5" fill="#E9E9E9" />
              <circle cx="53.5" cy="1.5" r="1.5" fill="#E9E9E9" />
              <circle cx="53.5" cy="27.5" r="1.5" fill="#E82862" />
              <circle cx="53.5" cy="53.5" r="1.5" fill="#E9E9E9" />
              <circle cx="53.5" cy="79.5" r="1.5" fill="#E82862" />
              <circle cx="53.5" cy="105.5" r="1.5" fill="#E9E9E9" />
              <circle cx="79.5" cy="1.5" r="1.5" fill="#E9E9E9" />
              <circle cx="79.5" cy="27.5" r="1.5" fill="#E9E9E9" />
              <circle cx="79.5" cy="53.5" r="1.5" fill="#E82862" />
              <circle cx="79.5" cy="79.5" r="1.5" fill="#E9E9E9" />
              <circle cx="79.5" cy="105.5" r="1.5" fill="#E9E9E9" />
              <circle cx="105.5" cy="1.5" r="1.5" fill="#E9E9E9" />
              <circle cx="105.5" cy="27.5" r="1.5" fill="#E9E9E9" />
              <circle cx="105.5" cy="53.5" r="1.5" fill="#E9E9E9" />
              <circle cx="105.5" cy="79.5" r="1.5" fill="#E9E9E9" />
              <circle cx="105.5" cy="105.5" r="1.5" fill="#E9E9E9" />
            </g>
          </svg>
        </div>
      </div>
    </div>
  </div>
  <el-dialog
    v-model="showCodeDialog"
    :title="messages.codeP[store.langSelect.value]"
    width="375px"
    :show-close="false"
    center
  >
    <p style="word-break: break-word">
      {{ messages.codeT[store.langSelect.value] }}
    </p>
    <div style="margin-top: 20px">
      <div
            :class="[
              !loginClass
                ? 'login_form_input el-input'
                : 'login_form_input_error el-input',
            ]"
          >
      <div class="el-input__wrapper">
      <input
        :placeholder="messages.codeP[store.langSelect.value]"
        v-model="checkCode"
        class="el-input__inner"
      />
      </div>
      <div style="margin-top: -20px; margin-bottom: 5px; height: 15px">
        {{ errCheckCode }}
        <span
          v-if="errCheckCodeClass"
          v-text="messages.checkCodeErr[store.langSelect.value]"
        >
        </span>
      </div>
      </div>
      <Button
        style="width: 180px; margin-top: 20px"
        @click="CheckCode"
        :text="messages.login[store.langSelect.value]"
      />
    </div>
  </el-dialog>
</template>
<script>
import HeaderLogin from "@/components/HeaderLogin";
import Button from "@/components/Button";
import axios from "axios";
import { useMyStorage } from "@/store/global";
import { ref, watch } from "vue";
import { useRouter } from "vue-router";
import md5 from "js-md5";

export default {
  components: {
    HeaderLogin,
    Button,
  },
  name: "LoginPage",
  setup() {
    const router = useRouter();
    const store = useMyStorage();
    const login = ref("");
    const errLogin = ref("");
    const loginClass = ref(false);
    const errLoginHist = ref("");
    const checkCode = ref("");
    const email = ref("");
    const errCheckCode = ref("");
    const errCheckCodeClass = ref(false);
    const messages = {
      loginH: ["АВТОРИЗОВАТЬСЯ", "Sign in"],
      login: ["Войти", "Submit"],
      userName: ["Имя пользователя", "Username"],
      password: ["Пароль", "Password"],
      forgotPassword: ["Забыли пароль?", "Forgot password?"],
      registerNew: [
        "Ещё нет аккаунта? Зарегистрируйтесь",
        "Don't have an account yet? Sign Up",
      ],
      loginErr: [
        "Не верно указан логин или пароль",
        "Login or password is incorrect",
      ],
      codeT: [
        "На ваш email отправлен код подтверждения. Введите его пожалуйста.\n" +
          '(Если письмо долго не приходит то, проверьте пожалуйста папку "Спам", особенно если у вас mail.ru)',
        "A verification email has been sent to your email. Please enter the code to complete registration.",
      ],
      codeP: ["Код подтверждения", "Code"],
      checkCode: [],
      checkCodeErr: ["Не верный код", "Incorrect code"],
    };
    let request = false;
    watch(login, () => {
      if (errLogin.value != "") {
        if (login.value != errLoginHist.value && login.value.length > 2) {
          loginClass.value = false;
          errLogin.value = "";
          passwordClass.value = false;
          errPass.value = "";
        }
      }
    });
    const salt = "$1$ae_salt";
    const password = ref("");
    const passwordClass = ref(false);
    const errPass = ref("");
    const errPassHist = ref("");
    const showCodeDialog = ref(false);
    watch(password, () => {
      if (errPass.value != "") {
        if (password.value != errPassHist.value && password.value.length > 6) {
          passwordClass.value = false;
          errPass.value = "";
          loginClass.value = false;
          errLogin.value = "";
        }
      }
    });
    watch(store.loginStatus, (newV) => {
      if (newV) {
        router.push(store.oldPath);
      }
    });
    const SubmitCode = () => {
      if (store.ServerUrl.indexOf("lktest") > -1) {
        console.log(store.ServerUrl);
        Login();
        return;
      }
      if (store.currentServer == 0) {
        console.log(store.ServerUrl);
        Login();
        return;
      }
      checkCode.value = "";
      errCheckCodeClass.value = false;
      errCheckCode.value = "";
      const data = {
        login: login.value,
      };
      axios
        .post(store.ServerUrl + "/users/sendcheckcode", data)
        .then(function (response) {
          if (response.data.code === 0) {
            if (response.data.data.email === "") {
              errLogin.value = "Пользователь не найден";
            } else {
              email.value = response.data.data.email;
              showCodeDialog.value = true;
            }
          }
        });
    };
    const CheckCode = () => {
      axios
        .get(
          store.ServerUrl +
            "/users/checkcode/" +
            email.value +
            "/" +
            checkCode.value
        )
        .then(function (response) {
          if (response.data.code === 0) {
            showCodeDialog.value=false
            Login();
          } else {
            errCheckCodeClass.value = true;
            errCheckCode.value = messages.checkCodeErr[store.langSelect.value];
          }
        });
    };
    const Login = () => {
      if (request) return;
      request = true;
      showCodeDialog.value=false
      const data = {
        login: login.value,
        pass: md5(password.value + salt),
      };
      axios
        .post(store.ServerUrl + "/users/loginUser", data)
        .then(function (response) {
          if (response.data.code != 0) {
            store.calcTicker.value = response.data.data.TickerForConver;
            store.Instruments[store.calcTicker.value] = { Last: 0, Sub: null };
            const msg = response.data.msg;
            const p = msg.indexOf("password");
            //console.log(p)
            if (p < 0) {
              loginClass.value = true;
              errLoginHist.value = login.value;
              errLogin.value = "Пользователь не найден";
            } else {
              passwordClass.value = true;
              errPassHist.value = password.value;
              errPass.value = "Не верный пароль";
            }
            // console.log(response);
          } else {
            // store.loginStatusSet(true)
            store.userInfo.value = response.data.data;
            store.token.value = response.data.data.Token;
            store.CentrifugoPrefix.value = response.data.data.CentrifugoPrefix;
          }
          request = false;
        })
        .catch(function (error) {
          console.log(error);
          loginClass.value = true;
          passwordClass.value = true;
          errLogin.value = "Пользователь не найден";
          errPass.value = "Не верный пароль";
          request = false;
        });
    };
    return {
      login,
      errLogin,
      loginClass,
      errLoginHist,
      password,
      passwordClass,
      errPass,
      errPassHist,
      Login,
      messages,
      store,
      showCodeDialog,
      SubmitCode,
      checkCode,
      errCheckCodeClass,
      CheckCode,
    };
  },
  data() {
    return {};
  },

  /* async Login() {
     const data = {
       login: this.login,
       pass: this.password,
     };
     try {
       let response = await this.$auth.loginWith('local', { data: data })

       if(response.data.code!=0){
         const msg =response.data.msg
         const p=msg.indexOf("password")
//console.log(p)
         if(p<0){
           this.loginClass=true
           this.errLoginHist=this.login
           this.errLogin="Пользователь не найден"
         }else{
           this.passwordClass=true
           this.errPassHist=this.password
           this.errPass="Не верный пароль"
         }
       }
       this.$store.commit('setUserInfo',response.data.data)
    //   this.$auth.setUserToken(response.data.data.Token,response.data.data.Token)
     //  this.$auth.setUser(response.data.data)
    //   console.log(response.data.data)
     } catch (err) {
       console.log(err)
     }
   }*/
};
</script>
<style lang="scss">
#login_body {
  color: #333;
  //   background-color: #e9e9e9;
  background-color: #222;
  width: 100%;
  height: 100%;
}

.login_form_input {
 // border: 1px solid #c4c4c4;
  padding: 2px 0;
 // height: 20px;
 // width: 291px;
  margin-bottom: 20px;
  background-image: none;
  /* border: none;
   Пароль */
  font-family: Roboto Regular;
  font-style: normal;
  font-weight: normal;
  font-size: 17px;
  line-height: 20px;
  /* identical to box height */

  /* color: #a5a5a5;*/
}

.login_form_input:focus {
  border: 1px solid #222;
  background-image: none;
  outline: none;
}

#login_link_group {
  display: flex;
}

#login_form a {
  font-family: Roboto Regular;
  font-style: normal;
  font-weight: normal;
  font-size: 15px;
  line-height: 18px;
  color: #333;
  text-underline-position: under;
}

#login_form a:hover {
  font-family: Roboto Regular;
  font-style: normal;
  font-weight: normal;
  font-size: 15px;
  line-height: 18px;
  color: #e82862;
  text-underline-position: under;
}

#login_register {
  margin-top: 30px;
  font-family: Roboto Regular;
  font-style: normal;
  font-weight: normal;
  font-size: 15px;
  line-height: 18px;
  color: #333;
}

.login_form_input_error {
  /* border: 1px solid #c4c4c4; */
  padding: 12px 20px;
  height: 20px;
  width: 291px;
  margin-bottom: 20px;
  background-image: none;
  /* border: none;
   Пароль */
  font-family: Roboto Regular;
  font-style: normal;
  font-weight: normal;
  font-size: 17px;
  line-height: 20px;
  /* identical to box height */

  /* color: #a5a5a5;*/
  border: 1px solid #e82862;
  background-image: none;
  outline: none;
}

#errLogin,
#errPass {
  color: #e82862;
}
.login_form_input_pass,
.login_form_input_pass_error {
  height: 44px;
  margin-bottom: 20px;
}

.login_form .el-input__wrapper {
  border-radius: 0 !important;
  border: 1px solid #c4c4c4;
  box-shadow: none;
  padding: 12px 20px;
  color: #a5a5a5 !important;
  font-family: Roboto Regular;
  font-style: normal;
  font-weight: normal;
  font-size: 17px;
  line-height: 20px;
}
.login_form_input_pass_error .el-input__wrapper {
  border-radius: 0;
  border: 1px solid #e82862;
  box-shadow: none;
  padding: 12px 20px;
  color: #a5a5a5 !important;
  font-family: Roboto Regular;
  font-style: normal;
  font-weight: normal;
  font-size: 17px;
  line-height: 20px;
}
.el-input__wrapper {
  border-radius: 0 !important;
  border: 1px solid #c4c4c4;
  box-shadow: none;
}
.is-focus .el-input__wrapper.is-focus {
  border: 1px solid #222;
  box-shadow: none;
}
.el-input__wrapper.is-focus {
  border: 1px solid #222;
  box-shadow: none !important;
}
.el-select .el-input__wrapper.is-focus {
  border: 1px solid #222;
  box-shadow: none !important;
}
.el-input__wrapper input::placeholder {
  color: #6c6c6c;
}
.login_form_input_pass .el-input__wrapper input {
  color: #222;
}
.login_form_input .el-input__wrapper input {
  border: none;
  color: #222;
}
/*.el-input--suffix.login_form_input_pass_error .el-input__inner {
  border: 1px solid #e82862 !important;
}

.login_form_input_pass_error .el-input__suffix,
.login_form_input_pass .el-input__suffix {
  margin-top: 3px;
}

.el-input--suffix.login_form_input_pass_error .el-input__inner,
.el-input--suffix.login_form_input_pass .el-input__inner {
  padding: 12px 20px !important;
  height: 46px !important;
  width: 333px !important;
  margin-bottom: 20px;
}

.el-input--suffix.login_form_input_pass .el-input__inner::placeholder {
  color: #6c6c6c;
}*/

/*input::placeholder {
  color: #6c6c6c;
  
}*/
@media (max-height: 520px){
  #full_login_form {
    top: 0 !important;
    transform: translate(-50%, 0) !important;
  }
}
@media (min-width: 750px) {
  #full_login_form {
    width: 749px;
    height: 525px;
    position: absolute;
    top: 50%;
    left: 50%;
    margin-right: -50%;
    transform: translate(-50%, -50%);
    #login_header {
      width: 749px;
      height: 141px;
    }

    #login_content {
      width: 749px;
      height: 384px;
      box-shadow: 0 12px 20px rgba(0, 0, 0, 0.06);
      display: flex;
      border-radius: 0 0 40px;
      #login_form {
        width: 331px;
        height: 264px;
        background-color: white;
        padding: 60px;

        #login_title {
          margin-bottom: 20px;
          font-family: Proxima Nova Condensed;
          font-style: normal;
          /* font-weight: 600;*/
          font-size: 20px;
          line-height: 24px;
          text-transform: uppercase;
          color: #222222;
        }
      }
    }
    #login_img {
      position: relative;
      width: 298px;
      height: 384px;
      /*background-size: 47px 31px;*/
      /*background: url('/lk/images/Rectangle24.png');*/
    }
  }
}

@media (max-width: 750px) {
  .el-dialog{
    width: 100% !important;
  }
  #full_login_form {
    width: 100%;
    height: 525px;
    position: absolute;
    top: 50%;
    left: 50%;
    margin-right: -50%;
    transform: translate(-50%, -50%);
    #login_header {
      width: 100%;
      height: 141px;
    //  overflow: hidden;
    }

    #login_content {
      width: 100%;
      height: 384px;
      box-shadow: 0 12px 20px rgba(0, 0, 0, 0.06);
      display: flex;

      #login_form {
        width: 100%;
        height: 264px;
        background-color: white;
        padding: 30px 10px;

        #login_title {
          margin-bottom: 20px;
          font-family: Proxima Nova Condensed;
          font-style: normal;
          /* font-weight: 600;*/
          font-size: 20px;
          line-height: 24px;
          text-transform: uppercase;
          color: #222222;
        }
      }
      #login_img {
        display: none;
        /*background-size: 47px 31px;*/
        /*background: url('/lk/images/Rectangle24.png');*/
      }
    }
  }
}
</style>
